module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/68.693894a3.png";